import { withKeys as _withKeys, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0 mb-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "card card-body mb-0" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "form-group me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_6 = { class: "col p-0" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "form-group col" }
const _hoisted_10 = { class: "col-auto p-0 text-end" }
const _hoisted_11 = { class: "row m-4 mt-0" }
const _hoisted_12 = { class: "col-sm-12" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-sm-12" }
const _hoisted_15 = { class: "card card-body" }
const _hoisted_16 = { class: "overflow-auto" }
const _hoisted_17 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_18 = { class: "text-capitalize-first" }
const _hoisted_19 = { class: "text-capitalize-first" }
const _hoisted_20 = { class: "text-capitalize-first" }
const _hoisted_21 = { class: "text-capitalize-first" }
const _hoisted_22 = { class: "text-capitalize-first" }
const _hoisted_23 = { class: "text-capitalize-first" }
const _hoisted_24 = { class: "text-capitalize-first" }
const _hoisted_25 = { class: "text-end" }
const _hoisted_26 = {
  key: 0,
  class: "fa fa-eye-slash"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = {
  key: 2,
  class: "fa fa-warning text-warning ms-2"
}
const _hoisted_37 = { class: "text-end" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrafficGroupForm = _resolveComponent("TrafficGroupForm")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_TrafficGroupRateChangeForm = _resolveComponent("TrafficGroupRateChangeForm")!
  const _component_b_pagination = _resolveComponent("b-pagination")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-sm",
                      onKeydown: _cache[0] || (_cache[0] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
                      placeholder: _ctx.helper.trans('labels.search_traffic_group'),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestDTO.query) = $event))
                    }, null, 40, _hoisted_8), [
                      [_vModelText, _ctx.requestDTO.query]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                    class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                  }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                    class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                  }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("table", _hoisted_17, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                        _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.helper.trans('labels.type')), 1),
                        _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.helper.trans('labels.name')), 1),
                        _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.helper.trans('labels.group_payment_option')), 1),
                        _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.helper.trans('labels.team_fee')), 1),
                        _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.helper.trans('labels.merchant_fee')), 1),
                        _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.helper.trans('labels.margin_fee')), 1),
                        _createElementVNode("th", _hoisted_25, [
                          (_ctx.store.getters.isAdmin)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showEditModal())),
                                class: "btn btn-outline-primary btn-sm text-capitalize"
                              }, _toDisplayString(_ctx.helper.trans('button.create')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(_component_b_modal, {
                            title: _ctx.createModalTitle,
                            modelValue: _ctx.createModal,
                            "body-class": "pt-0",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.createModal = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_TrafficGroupForm, { ref: "createForm" }, null, 512)
                            ]),
                            footer: _withCtx(() => [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.createModal = false)),
                                class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                              }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
                              _createVNode(_component_LoaderWrapper, {
                                ref: "loaderCreateFrom",
                                zoom: 0.5
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.save())),
                                    class: "btn btn-outline-primary btn-sm text-capitalize-first"
                                  }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
                                ]),
                                _: 1
                              }, 512)
                            ]),
                            _: 1
                          }, 8, ["title", "modelValue"]),
                          _createVNode(_component_b_modal, {
                            title: _ctx.rateChangeModalTitle,
                            modelValue: _ctx.rateChangeModal,
                            "body-class": "pt-0",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.rateChangeModal = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_TrafficGroupRateChangeForm, {
                                ref: "rateChangeForm",
                                trafficGroupId: _ctx.selectedTrafficGroupId
                              }, null, 8, ["trafficGroupId"])
                            ]),
                            footer: _withCtx(() => [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.rateChangeModal = false)),
                                class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                              }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
                              _createVNode(_component_LoaderWrapper, {
                                ref: "loaderRateChangeFrom",
                                zoom: 0.5
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.saveRateChange())),
                                    class: "btn btn-outline-primary btn-sm text-capitalize-first"
                                  }, _toDisplayString(_ctx.helper.trans('button.apply')), 1)
                                ]),
                                _: 1
                              }, 512)
                            ]),
                            _: 1
                          }, 8, ["title", "modelValue"]),
                          _createVNode(_component_b_modal, {
                            title: _ctx.deleteModalTitle,
                            modelValue: _ctx.deleteModal,
                            "body-class": "pt-0",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.deleteModal = $event))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", null, _toDisplayString(_ctx.helper.trans('messages.confirm_delete_traffic_group', {name: _ctx.selectedTrafficGroupName})), 1)
                            ]),
                            footer: _withCtx(() => [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.deleteModal = false)),
                                class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                              }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
                              _createVNode(_component_LoaderWrapper, {
                                ref: "loaderDelete",
                                zoom: 0.5
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.deleteTrafficGroup())),
                                    class: "btn btn-outline-danger btn-sm text-capitalize-first"
                                  }, _toDisplayString(_ctx.helper.trans('button.delete')), 1)
                                ]),
                                _: 1
                              }, 512)
                            ]),
                            _: 1
                          }, 8, ["title", "modelValue"])
                        ])
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.items, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.id,
                          class: ""
                        }, [
                          _createElementVNode("td", null, [
                            _createTextVNode(_toDisplayString(item.id) + " ", 1),
                            (item.isHidden)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_26))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`direction.${item.type}`)), 1),
                          _createElementVNode("td", null, [
                            _createTextVNode(_toDisplayString(item.name) + " ", 1),
                            (item.publicName)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_27, "(" + _toDisplayString(item.publicName) + ")", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            (item.paymentOptions?.length)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.paymentOptions, (option) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: option,
                                    class: "badge bg-primary me-1"
                                  }, _toDisplayString(_ctx.helper.trans(`payment_options.${option}`)), 1))
                                }), 128))
                              : (_openBlock(), _createElementBlock("span", _hoisted_28, "—"))
                          ]),
                          _createElementVNode("td", null, [
                            (item._traderGroupSummaryItem)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  (item._traderGroupSummaryItem.minReward === item._traderGroupSummaryItem.maxReward)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.numberFormatter.formatNumber(item._traderGroupSummaryItem?.minReward * 100, 2)), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.numberFormatter.formatNumber(item._traderGroupSummaryItem?.minReward * 100, 2)) + "/" + _toDisplayString(_ctx.numberFormatter.formatNumber(item._traderGroupSummaryItem?.maxReward * 100, 2)), 1))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            (item.minReward === item.maxReward)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.numberFormatter.formatNumber(item.minReward * 100, 2)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.numberFormatter.formatNumber(item.minReward * 100, 2)) + "/" + _toDisplayString(_ctx.numberFormatter.formatNumber(item.maxReward * 100, 2)), 1))
                          ]),
                          _createElementVNode("td", null, [
                            (item.minReward - (item._traderGroupSummaryItem?.maxReward ?? 0) === item.maxReward - (item._traderGroupSummaryItem?.minReward ?? 0) )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.numberFormatter.formatNumber((item.minReward - (item._traderGroupSummaryItem?.maxReward ?? 0)) * 100, 2)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.numberFormatter.formatNumber((item.minReward - (item._traderGroupSummaryItem?.maxReward ?? 0)) * 100, 2)) + "/" + _toDisplayString(_ctx.numberFormatter.formatNumber((item.maxReward - (item._traderGroupSummaryItem?.minReward ?? 0)) * 100, 2)), 1)),
                            ((item._traderGroupSummaryItem?.minReward ?? 0) >= 0 && item.minReward - (item._traderGroupSummaryItem?.maxReward ?? 0) < 0.01)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_36))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_37, [
                            (_ctx.store.getters.isAdmin)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.showRateChangeModal(item)),
                                  class: "btn btn-sm btn-outline-primary text-nowrap text-capitalize me-2"
                                }, [
                                  _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fa fa-percent" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.rates')), 1)
                                ], 8, _hoisted_38))
                              : _createCommentVNode("", true),
                            (_ctx.store.getters.isAdmin)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.showEditModal(item)),
                                  class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2"
                                }, [
                                  _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fa fa-pencil" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.edit')), 1)
                                ], 8, _hoisted_39))
                              : _createCommentVNode("", true),
                            (_ctx.store.getters.isAdmin)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.showDeleteModal(item)),
                                  class: "btn btn-sm btn-outline-danger text-nowrap text-capitalize"
                                }, [
                                  _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fa fa-trash" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.delete')), 1)
                                ], 8, _hoisted_40))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.response.totalCount > _ctx.response.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": [
                          _cache[14] || (_cache[14] = ($event: any) => ((_ctx.page) = $event)),
                          _cache[15] || (_cache[15] = ($event: any) => (_ctx.loadList()))
                        ],
                        "total-rows": _ctx.response.totalCount,
                        "per-page": _ctx.response.limit,
                        limit: 20,
                        "prev-text": "Back",
                        "next-text": "Next",
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}